import React from "react";
import { useNavigate } from "react-router-dom";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { getId, getQuotationFor } from "../../../Components/Functions/word.fun";
import { BsArrowRightShort } from "react-icons/bs";
import { FaStar } from "react-icons/fa";

const tableHead = [
  "Sr.",
  "",
  "Quotation Date",
  "Quotation Type",
  // "Area (SqMtr)",
  "Contact Name",
  "Amount ( - GST)",
  "Generated By",
  "Action",
];

const getTotalAmt = (quotation) => {
  if (quotation?.quotationNumber?.includes("A/V2")) {
    let amt = 0;

    amt = quotation?.quotationMatrixCost?.asPerIndustryCost;

    return roundOffCost(amt || 0);
  } else {
    let total = 0;
    if (+quotation?.input_info?.overrideUnitCost > 0) {
      total += +quotation?.input_info?.overrideUnitCost;
    } else {
      total = quotation?.quotationMatrixCost?.total_cost;
    }
    if (
      quotation?.input_info?.addOnParticulars &&
      quotation?.input_info?.addOnParticularsPrice
    ) {
      total += +quotation?.input_info?.addOnParticularsPrice;
    }
    total = roundOffCost(total);
    return total;
  }
};

const returnBadge = (finalQuotation, overrideUnitCost) => {
  if (finalQuotation && !overrideUnitCost) {
    return <span className="badge bg-success ms-1"></span>;
  } else if (overrideUnitCost && !finalQuotation) {
    return <FaStar style={{ color: "orange", marginBottom: "5px" }} />;
  } else if (finalQuotation && overrideUnitCost) {
    return <FaStar style={{ color: "green", marginBottom: "5px" }} />;
  }
};

const AllQuotations = ({ quotations = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(
      id.includes("A/V2")
        ? `/custom-quotation-v2/${getId(id)}`
        : `/custom-quotation/${getId(id)}`
    );
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter" style={{ gap: "5px" }}>
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return (
                <th
                  style={{
                    width: item === "Generated By" ? "10%" : "",
                  }}
                  key={index}
                >
                  {item}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {quotations?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.quotationNumber}>
                <td>{Index}</td>
                {/* <td>{getId(item?.quotationNumber) || "N/A"}</td> */}
                <td>
                  {" "}
                  {returnBadge(
                    item?.input_info?.finalQuotation,
                    +item?.input_info?.overrideUnitCost
                  )}
                </td>
                <td>
                  {item?.input_info?.quotationDate || "N/A"}
                  <div>
                    {(item?.quotationNumber || item?.aifQuotationNumber) && (
                      <span className="border-top">
                        <b>
                          {item?.quotationNumber || item?.aifQuotationNumber}
                        </b>
                      </span>
                    )}
                  </div>
                </td>

                <td>
                  {item?.area_in?.area_in_sqmeter || "N/A"} SqM
                  <br />
                  <span className="text-secondary">
                    {getQuotationFor(item?.input_info) || "N/A"}
                  </span>
                </td>
                <td>
                  {item?.input_info?.contactPersonName || "N/A"} <br />{" "}
                  <span className="text-secondary badge bg-cyan-lt">
                    {item?.input_info?.phoneNumber || "N/A"}
                  </span>
                </td>
                <td>{getTotalAmt(item) || "N/A"}</td>
                <td>{item?.input_info?.genrated_by || "N/A"}</td>

                <td>
                  <button
                    className="btn btn-primary px-3 btn-sm"
                    onClick={() => goToView(item?.quotationNumber)}
                  >
                    <BsArrowRightShort className="me-1" /> View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllQuotations;
